import React from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useContent } from './context/ContentContext';
import Layout from './components/Layout';
import Loading from './components/Loading';
import DifyChat from './components/DifyChat';

// Pages
import Home from './pages/Home';
import Careers from './pages/Careers';
import NotFound from './pages/NotFound';

// Admin Pages
import Admin from './admin/Admin';
import Dashboard from './admin/Dashboard';
import SiteSettings from './admin/SiteSettings';
import Content from './admin/Content';
import Media from './admin/Media';

function App() {
  const location = useLocation();
  const { loading } = useContent();

  if (loading) return <Loading />;

  return (
    <>
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          {/* Public Routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="careers" element={<Careers />} />

            {/* 重定向所有旧页面路由到首页 */}
            <Route path="about" element={<Navigate to="/#about" replace />} />
            <Route path="services" element={<Navigate to="/#services" replace />} />
            <Route path="projects" element={<Navigate to="/#projects" replace />} />
            <Route path="blog" element={<Navigate to="/#blog" replace />} />
            <Route path="contact" element={<Navigate to="/#contact" replace />} />
            
            {/* 通配符路由捕获所有其他公共路径 */}
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin" element={<Admin />}>
            <Route index element={<Dashboard />} />
            <Route path="settings" element={<SiteSettings />} />
            <Route path="content" element={<Content />} />
            <Route path="media" element={<Media />} />
          </Route>
        </Routes>
      </AnimatePresence>
      
      {/* Add DifyChat component */}
      <DifyChat />
    </>
  );
}

export default App; 